import { initialStatePhoneNumber, PhoneNumber } from "@medere/medere-ui-framework";
import { ComboDataDTO } from "../dto/ComboDataDTO"


export interface DocumentType {
    documentType: number,
    shortName: string,
    longName: string,
    externalCode: string
}

export interface VatCustomerCategory {
    vatcustomercategory: number,
    categoryname: string
}

export interface PaymentMethod {
    paymentMethod: number,
    methodName: string,
    _order: number,
    active: boolean,
    i18ncodes: [],
}

export interface PaymentCondition {
    paymentcondition: number,
    code: string,
    description: string,
}

export interface EarningWithHolding {
    earningwithholding: number;
    regimecode: string;
    description: string;
    registeredtaxpayers: string;
    unregisteredindividuals: string;
    unregisteredeothers: string;
    amountsexempt: string;
    active: boolean;
}

export interface SupplierType {
    suppliertype: number,
    code: string,
    description: string
}

export interface SupplierTypeDTO extends SupplierType {
    fulldescription: string,
}

export interface CustomLocation {
    city: number,
    location: string,
}

export interface Accounting {
    accounting: number,
    company: number,
    description: string,
    treesize: number
}

export interface AccountTypeDTO {
    id: number,
    description: string,
    accounttypecategory: number
}

export interface AccountingAccount {
    accountingaccount: number,
    description: string,
    accounting: number,
    identifier: string,
    fulldescription: string,
    allowsmovements: boolean,
    alias: string,
    level: string,
    parentaccountingaccountpk: number
}

export interface ComboBoxParams {
    inputText: string,
    offset: number,
    pageSize: number,
    params: any
}

export interface ArbaReceipt {
    numeroComprobante: number;
    fechaDesde: number;
    fechaHasta: number;
    cantidadContribuyentes: number;
    contribuyentes: ContribuyentItem[];
}

export interface ContribuyentItem {
    contribuyente: ArbaReceiptContributor;
}

export interface ArbaReceiptContributor {
    cuitContribuyente: number;
    alicuotaPercepcion: string;
    alicuotaRetencion: string;
    grupoPercepcion: number;
    grupoRetencion: number;
}


export enum ETaxType {
    "PERCEPCION IIBB" = 0,
    "IVA 0" = 0,
    "IVA EXENTO" = 0,
    "IVA 2.5" = 2.5,
    "IVA 5" = 5,
    "IVA 10.5" = 10.5,
    "IVA 21" = 21,
    "IVA 27" = 27,
}

export interface AccountingPeriod {
    accountingperiod: number,
    type: string,
    description: string,
    company: number,
    beginningdate: string,
    closingdate: string,
    recorddate: string,
    _user: number,
    _username: string,
}

export interface AdministrativeForm {
    administrativeform: number;
    address: string;
    amount: number;
    date: string;
    description: string;
    document: string;
    entityname: string;
    exemptamount: number;
    formnumber: number;
    netamount: number;
    netamountnottaxed: number;
    pendingamount: number;
    servicefrom: string;
    serviceto: string;
    services: string;
    taxesamount: number;
    vatamount: number;
    _user: number;
    administrativeformstatetype: number;
    administrativeformtype: number;
    documenttype: number;
    paymentmethod: number;
    pos: number;
    vatcustomercategory: number;
    billingname: string;
    billingaddress: string;
    billingdocument: string;
    billingdocumenttype: number;
    billingvatcategory: number;
    customerentity: number;
    billingentity: number;
    inguarantee: boolean;
    billingfcecbu: string;
    billingfcealias: string;
    billingfcedayspaymentdue: number;
    billingfcesca: boolean;
    billingfceacd: boolean;
    billingfcenulled: boolean;
    posnumber: number;
    external: boolean;
    accountdate: string;
    expirationdate: string;
    paywithcreditcard: boolean;
    issgr: boolean;
    formdate: string;
}

export interface AdminFormDTO {

    entity: number;
    accountid: string;
    address: string;
    document: string;
    entityname: string;
    pos: number;
    alias: string;
    language: number;
    administrativeform: number;
    receipttype: string;
    administrativeformstatetype: number;
    statedesc: string;
    posnumber: number;
    date: string;
    formnumber: number;
    paymentmethod: number;
    paymentmethoddesc: string;
    amount: number;
    pendingamount: number;
    balance: number;
    collector: string;
    
    entitytype: number;
    entitytypedesc: string;
    adminformdesc: string;
    doctype: string;

    afamountdebit: number;
    afamountcredit: number;
    afrelatedstr: string;
    signus: string;

    netamount: number;
    netamountnottaxed: number;
    vatamount: number;
    taxesamount: number;
    exemptamount: number;

    typegroup: number;

    accountmovement: number;
    administrativeformtype: number;

    nulledby: number;

    userid: number;
    adminformuser: string;

    receiptstate: number;
    cae: string;
    caedue: string;
    afipnotes: string;
    afipdatetime: string;

    invoicingprocesorlogstatus: number;
    invoicingprocesorlogstatusdesc: string;

    externalnumber: boolean;
    receiptstatedesc: string;

    logdate: string;
    note: string;
    loguserdata: string;

    entityzone: number;
    zonename: string;

    bankaccountid: string;
    creditcardname: string;
    creditcardnumber: string;
    vatidinvoicingcompany: string;

    billingentity: number;
    billingname: string;
    billingaddress: string;
    billingdocumenttype: number;
    billingvatcategory: number;
    amountForReport: string;
    pendingAmountForReport: string;
    balanceForReport: string;
    afAmountDebitForReport: string;
    afAmountCreditForReport: string;
    netAmountForReport: string;
    netAmountNotTaxedForReport: string;
    vatAmountForReport: string;
    taxesAmountForReport: string;
    exemptAmountForReport: string;
    inguarantee: boolean;
    healthentityid: number;
    healthentityname: string;
    healthentityplanid: number;
    healthentityplanname: string;
    effectorname: string;
    site: number;
    observations: string;
}

export interface TaxType {
    taxtype: number,
    taxvalue: number,
    taxname: string,
    vattax: boolean,
    taxaccount: number,
    accounting: number,
    editable: boolean,
    forsalesinvoices: boolean,
    forpurchaseinvoices: boolean,
    forpaymentstoothers: boolean,
    forpaymentsfromothers: boolean,
    isiibbwithholding: boolean,
    isearningswithholding: boolean,
    exemptvattax: boolean, 
    vatnottaxed: boolean
}

export interface TaxTypeDTO {
    taxname: string;
    taxpercentage: Big;
    isiibbwithholding: boolean
    isearningswithholding: boolean;
    taxaccount: number;
    taxtype:number;
}

export interface EarningWithholdingConceptDTO {
    withholdingconcept: number;
    description: string;
}

export interface AccountingMovementDetail {
    accountingmovementdetail: number,
    debitcredit: string,
    valueamd: number,
    balance: number,
    accountingaccount: number,
    accountingmovement: number,
    descriptionaccountingaccount: string,
    indexList: number,
    valueamd2: number,
}

export interface AccountingMovementType {
    accountingmovementtype: number,
    descriptionaccountingmovement: string,
}

export const defaultAllAccountingMovementType: AccountingMovementType = {
    accountingmovementtype: -1,
    descriptionaccountingmovement: '<Todos>',
};

export enum EAccountingMovementType {
    SUPPLIERS = 1,
    SALES = 2,
    SALARIES = 3,
    TREASURY = 4,
    ASSETS = 5,
    INVENTORYSTOCK = 6,
    ADJUSTMENTS = 7,
    CLOSUREENTRY = 8,
    OPENINGENTRY = 9,
    OTHER = 10,
}

export interface Bank {
    bank: number,
    companyname: string
}

export const initialStateBank: Bank = {
    bank: -1,
    companyname: ""
}

export interface BankAccount {
    active: boolean;
    bankaccount: number;
    bank: ComboDataDTO;
    accounttype: AccountTypeDTO|null
    currency: ComboDataDTO
    cbu: string;
    alias: string;
    notes: string;
    medereentity: number;
    accountingaccount: AccountingAccount|null;
    paymentmethodbanks: PaymentMethod[];
}

export interface BankAccountDTO {
    active: boolean;
    bankaccount: number;
    bank: number;
    bankdesc: string;
    accounttype: number;
    accounttypedesc: string;
    accounttypecategory: number;
    currency: number;
    currencydesc: string;
    cbu: string;
    alias: string;
    notes: string;
    medereentity: number;
    accountingaccount: number;
    accountingaccountdesc: string;
    paymentmethodbanks: PaymentMethod[];
}


export enum EVatCustomerCategory {
    IVA_RESPONSABLE = 1,
    IVA_EXENTO = 2,
    CONSUMIDOR_FINAL = 3,
    MONOTRIBUTISTA = 4,
    INSCRIPTO_M = 5,
    NO_INSCRIPTO = 6,
}

export interface AppointmentsDTO {
    deviceUUID: string;
    medicalschedulesetup: number;
    medicalscheduletemplate: number;
    patientcarequeue: number;
    dayofweek: number;
    appointmentstateid: number;
    appointmentstatecategoryid: number;
    medereentity: number;
    professional: number;
    medicalspeciality: number;
    scheduleactivitytype: number;
    descriptionappointmentstate: string;
    dayname: string;
    appointmentdatetime: Date;
    initialhour: string;
    endhour: string;
    duration: string;
    professionalnames: string;
    professionalids: string;
    specialityname: string;
    patientname: string;
    outofschedule: boolean;
    timezonename: string;
    locationsname: string;
    multisessionDates: string;
    building: string;
    buildingAddress: string;
    businessname: string;
    planname: string;
    benefitnumber: string;
    voluntary: boolean;
    docshortname: string;
    clinicalhistoryid: string;
    idnumber: string;
    activitytypename: string;
    templatedesc: string;
    patientqtybyappointment: number;
    qtypatients: number;
    isavailable: boolean;
    maxpatientsoutofschedulebyhour: number;
    qtyoutofscheduleapp: number;
    durationtooccupy: number;
    professionals: string;
    specialities: string;
    filterprofessional: number;
    filterspeciality: number;
    appointmentpermit: number;
    appointmenttotime: Date;
    notes: string;
    vcall: boolean;
    videocallsetup: boolean;
    facetofacesetup: boolean;
    email: string;
    companyPhone: string;
    mobilephone: string;
    phonenumber: string;
    address: string;
    siteuuid: string;
    deviceuuid: string;
    companyName: string;
    appointmentsgrouped: boolean;
    offerappointment: boolean;
    allowsappoinments: boolean;
    allowsspontaneous: boolean;
};

export enum YesNoENUM {
    YES = 1,
    NO = 2
}

export interface AdministrativeFormItemDTO {
    administrativeformitem: number
    itemtype: number
    description: string
    quantity: number
    subtotal: number
    totalamount: number
    creditamount: number
    unitprice: number
    vatamount: number
    period: string
    administrativeform: number
    taxtype: number
    taxname: string
    taxvalue: number
    exempttype: boolean
    producttype: number
    accountingaccount: number
    accountingaccountdesc: string
}

export interface AdministrativeFormTaxDTO {
    administrativeformtax: number
    taxtype: number
    taxbase: number
    taxamount: number
    taxvalue: number
    administrativeform: number
    taxname: string
    exempttype: boolean
    taxaccount: number
    taxaccountdesc: string
    taxaccountalias: string
    exemptvattax: boolean
    vatnottaxed: boolean
}

export interface AdministrativeFormStateTypeI18n {
    administrativeFormStateTypeI18n: number
    language: number
    description: string
}

export interface AdministrativeFormStateTypeI18nDTO {
    administrativeformstatetypei18n: number
    administrativeformtype: number
    shortdescription: string
    typedescription: string
    typeletter: string
    language: number
    description: string
}

export interface RecipeDTO {
    patient: PatientRecordDTO|null|undefined,
    medications: Medicine[],
    professional: Professional|undefined,
    hidepatientdata: boolean,
    starteddate: Date,
    servicedate: Date|null,
    issueasparticular: boolean|null,
    requestprescription: number|null,
    generaldiagnosis: string,
    prolongedtreatment: boolean,
    observations: string,
    monthdurationprescription: number
}

export interface FileDTO {
    pdfFileName: string;
    encodedPdf:string;
    id?: number;
    uuid?: string;
}

export interface RecipeAuditoryResponseDTO {
    recipeResponseDTO: RecipeResponseDTO[],
    requiresauditory: boolean
}

export interface RecipeResponseDTO {
    recipepdf: FileDTO;
    medicinePrescripted: Medicine[];
    success: boolean;
    message: string;
    digitalRpId: number;
}

export interface RecipeMessageDTO {
    messageTypeId: number;
    digitalRpFiles: (FileDTO|null|undefined)[];
    patientId: number;
    professionalId: number;
    digitalRpId: number|null;
}

export interface ScheduleMessageResponseDTO {
    success: boolean;
    message: string;
    statusCode: number;
    taskmessageid: number;
}

export interface Medicine {
    drug: number,
    drugdescription: string,
    externalidsubstance: string,
    medicinalproduct: number,
    medicinalproductdescription: string,
    externalidmedicinalproduct: string,
    presentation: number,
    presentationdescription: string,
    externalidpresentation: string,
    quantity: number,
    duplicate: boolean,
    indications: string,
    diagnosis: string,
    lastused: string,
    issubstance: boolean|undefined,
    codebar: string,
    active: boolean,
    salecondition: number,
    saleconditiondescription: string
}

export const defaultMedicine: Medicine = {
    drug: 0,
    drugdescription: '',
    externalidsubstance: '',
    medicinalproduct: 0,
    medicinalproductdescription: '',
    externalidmedicinalproduct: '',
    presentation: 0,
    presentationdescription: '',
    externalidpresentation: '',
    quantity: 0,
    duplicate: false,
    indications: '',
    diagnosis: '',
    lastused: '',
    issubstance: undefined,
    codebar: '',
    active: true,
    salecondition: 0,
    saleconditiondescription: ''
}

export interface MedicinalProductDTO {
    medicinalproduct: number;
    informationprovider: number;
    externalid: string;
    description: string;
    drugmanufacturer: number;
    drugmanufacturerdesc: string;
    psychotropictype: number;
    psychotropictypedesc: string;
    narcoticsubstance: boolean;
    salecondition: number;
    saleconditiondesc: string;
    active: boolean;
    requiresrefrigerator: boolean;
}

export interface MedicinalProductPresentationDTO /*extends MedicinalProductDTO*/ {
    medicinalproductpresentation: number;
    medicinalproductpresentationdesc: string;
    externalidpresentation: string;
    salecondition: number|null;
    saleconditiondesc : string;
    /*price: number;
    codebar: string;
    medicinalproductdesc: string;*/
}

export interface MedicinalProductsAndSubstancesDTO {
    description: string;
    presentationdescription: string;
    id: number;
    externalid: string;
    issubstance: boolean;
    informationprovider: number;
    medicinalproductpresentation: number;
    price: number;
    codebar: string;
    externalidpresentation: string;
    saleconditiondescription: string;
    salecondition: number;
    drugdescription: string;
    descriptionfull: string;
    externalidsubstance: string;
    medicinalproductdescription: string;
    medicinalproduct: number;
    substance: number;
    externalidmedicinalproduct: string;
    drugmanufacturername: string;
}

export interface Patient {
    medereentity: number,
    firstname: string,
    lastname: string,
    document: string,
    gender: string,
    birthdate: Date,
    phonenumber: string,
    email: string,
    insurances: Insurance[],
    observations: string
}

export interface PatientRecordDTO {
    medereentitytype: number;
    medereentity: number;
    active: boolean;
    fullname: string;
    firstname: string;
    lastname: string;
    document: string;
    documenttype: string;
    //healthentityid: number;
    //coverage: string;
    insurances: HealthPatientCoverage[]|undefined;
    insurancesToDelete: number[]|undefined;
    //entityplan: string;
    //benefitnumber: string;
    username: string;
    //coveragestart: Date;
    clinichistoryid: string;
    birthdate: Date | string | undefined;
    gender: string;
    address: string;
    mobilephone: string;
    email: string;
    entitytag: number;
    id: number;
    isonlypatient: boolean;
    //healthentityplan: number;
    typedesc: string;
    medereentityuserid: string;
    tags: string;
    tagsandcolors: string;
    fullpatientinfo: string;
    observations: string;
}

export const defaultNewPatientRecordDTO: PatientRecordDTO = {
    medereentitytype: 0,
    medereentity: 0,
    active: false,
    fullname: '',
    firstname: '',
    lastname: '',
    document: '',
    documenttype: '',
    //healthentityid: 0,
    //coverage: '',
    insurances: undefined,
    insurancesToDelete: undefined,
    //entityplan: '',
    //benefitnumber: '',
    username: '',
    //coveragestart: new Date(),
    clinichistoryid: '',
    birthdate: undefined,
    gender: 'M',
    address: '',
    mobilephone: '',
    email: '',
    entitytag: 0,
    id: 0,
    isonlypatient: false,
    //healthentityplan: 0,
    typedesc: '',
    medereentityuserid: '',
    tags: '',
    tagsandcolors: '',
    fullpatientinfo: '',
    observations: '',
}

export interface Insurance {
    id: number,
    name: string,
    plan: string,
    affiliateNumber: string,
    mandatory: boolean
}

export interface HealthEntity {
    healthentity: number,
    commercialname: string,
    recipevalidatorid: number
}

export const defaultHealthEntity: HealthEntity = {
    healthentity: 0,
    commercialname: '',
    recipevalidatorid: 4,
}

export interface HealthEntityPlan {
    healthentityplan: number,
    name: string,
    healthentity: HealthEntity
}

export const defaultHealthEntityPlan: HealthEntityPlan = {
    healthentityplan: 0,
    name: '',
    healthentity: defaultHealthEntity
}

export interface HealthPatientCoverage {
    healthpatientcoverage: number,
    benefitnumber: string,
    coveragestart: Date|undefined,
    coverageend: Date|undefined,
    primarycoverage: boolean,
    voluntary: boolean,
    healthentityplan: HealthEntityPlan,
    patient: number,
    description: string
}

export const defaultHealthPatientCoverage: HealthPatientCoverage = {
    healthpatientcoverage: 0,
    benefitnumber: '',
    coveragestart: undefined,
    coverageend: undefined,
    primarycoverage: false,
    voluntary: true,
    healthentityplan: defaultHealthEntityPlan,
    patient: 0,
    description: ''
}

export interface AttentionPlace {
    name: string,
    address: string,
    city: string,
    logo: string,
    websiteorsocialmedia: string
}

export const defaultAttentionPlace: AttentionPlace = {
    name: '',
    address: '',
    city: '',
    logo: '',
    websiteorsocialmedia: ''
}

export interface Professional {
    professionaid: number,
    firstname: string,
    lastname: string,
    document: string,
    documenttype: DocumentType | null
    imagewithdocument: string,
    prefix: string,
    workenrollmenttype: string,
    workenrollment: string,
    mobilephone: string,
    email: string,
    attentionplace: AttentionPlace|undefined,
    specialities: string,
    specialitiesList: MedicalSpeciality[],
    fulldescription: string,
    gender: string,
    address: string,
    province,
    cityId: number,
    city: string,
    fiscalCityId: number,
    fiscalCity: string,
    birthdate: Date | null,
    signaturedata: string
}

export interface MedicalSpeciality {
    medicalspeciality: number
    name: string
    systemspeciality: boolean
    allowsprescription: boolean
    delete: boolean,
    insert: boolean
}

export const defaultMedicalSpeciality: MedicalSpeciality = {
    medicalspeciality: -1,
    name: '',
    systemspeciality: true,
    allowsprescription: true,
    delete: false,
    insert: false
}

export const defaultProfessional: Professional = {
    professionaid: 0,
    firstname: '',
    lastname: '',
    document: '',
    documenttype: null,
    imagewithdocument: '',
    prefix: '',
    workenrollmenttype: '',
    workenrollment: '',
    mobilephone: '',
    email: '',
    attentionplace: defaultAttentionPlace,
    specialities: '',
    specialitiesList: [defaultMedicalSpeciality],
    fulldescription: '',
    gender: 'M',
    address: '',
    province: '',
    city: '',
    birthdate: null,
    signaturedata: '',
    cityId: -1,
    fiscalCityId: -1,
    fiscalCity: ''
}

export interface UserAllowedToPrescript {
    medereentity: number|null,
    firstname: string|null,
    lastname: string|null,
    document: string|null,
    mobilephone: string|null,
    email: string|null,
    fulldescription: string|null,
    delete: boolean|null,
    insert: boolean|null
}

export interface RequestedPrescriptions {
    requesteddate: Date;
    healthpatientcoverage: number;
    statedescription: string;
    patientfullname: string;
    professional: string;
    professionalid: number;
    medicinesfulldescription: string;
    patientid: number;
    prescriptionrequest: number;
    currentstate: number;
    rejectionreason: string;
}

export interface PrescriptionRequestResponseDTO {
    rejectiondescription: string,
    digitalrp: number
}

export interface DigitalRpForHistoryDTO {
    professionalid: number;
    patientid: number;
    userprescriptorid: number;
    digitalrpid: number;
    medicineprescribeddescription: string;
    uuid: string;
    patientfullname: string;
    dateprescribed: Date;
    pdfpath: string;
    pdffile: string;
}

export enum SaleCondition {
    FreeSale = 1,
    DirectSaleToHealthcareInstitutions = 2,
    ArchivedPrescription = 3,
    PrescriptionRequired = 4
}

export interface POSType{
    posType: number;
    description: string;
}
export interface WithholdingRequestDTO {
  responsabilitytype: number;
  persontype: number;
  withholdingconcept: number;
  withholdingtypes: number[];
  newamount: number;
  accumulatedamountofactualperiod: number;
  accumulatedwithholdingsamount: number;
  professionalCuit: string;
  handlingType: number; // 1 retención -- 2 percepción 
  dateFrom: string;
  dateTo: string;
  provinceID: number;
  forceWithholding: boolean;
  alternativeTaxRate: number;
}
export interface WithholdingResponseDTO {
    withholdingValue: number;
    message: string;
    responseOk: boolean;
}

export enum OperationType {
    FOR_PURCHASE_INVOICES = 1,
    FOR_SALES_INVOICES = 2,
    FOR_PAYMENTS_TO_OTHERS = 3,
    FOR_PAYMENTS_FROM_OTHERS = 4
}

export interface SitePropertiesDTO {
    siteproperty: number;
    site: number;
    usedefaultcontact: boolean;
    defaultemail: string;
    defaultmobilephone: string;
    hassenderpermission: boolean;
}

export interface Office {
    hospitallocation: number;
    description: string;
    locationtype: number; //Si es 4, es un Box/Puesto de atencion. Si es otro, es un tipo de consultorio
    locationtypestring: string;
    quantityofpatientsallowed: number;
    active: boolean;
    sector: number;
    sectorstring: string;
    building: number;
}

export const defaultOffice: Office = {
    hospitallocation: -1,
    description: '',
    locationtype: 0,
    locationtypestring: '',
    quantityofpatientsallowed: 0,
    active: true,
    sector: -1,
    sectorstring: '',
    building: -1
};

export interface Box {
    hospitallocation: number;
    description: string;
    locationtype: number; //Si es 4, es un Box/Puesto de atencion. Si es otro, es un tipo de consultorio
    sector: number;
    sectorstring: string;
    active: boolean;
    hardwareid: string;
    building: number;
}

export const defaultBox: Box = {
    hospitallocation: -1,
    description: '',
    locationtype: 4, // por defecto tipo Box
    sector: -1,
    sectorstring: '',
    active: true,
    hardwareid: null,
    building: -1
};

export interface LoacationType {
    locationtype: number;
    description: string;
}

export interface Sector {
    sector: number;
    name: string;
    sectortype: number;
    sectortypedescription: string;
    externalcode: string;
    repositorytype: number;
    repositorytypedescription: string;
    parentsector: number;
    parentsectorname: string; //workingRepository
    shortname: string;
    acceptpatienttransfers: boolean;
    restrictroomgendercontrol: boolean;
    prescriptionpriority: number | null;
    active: boolean;
    building: number;
    buildigname: string;
}

export const defaultSector: Sector = {
    sector: -1,
    name: '',
    sectortype: 0,
    sectortypedescription: '',
    externalcode: '',
    repositorytype: 0,
    repositorytypedescription: '',
    parentsector: -1,
    parentsectorname: '',
    shortname: '',
    acceptpatienttransfers: false,
    restrictroomgendercontrol: true,
    prescriptionpriority: null,
    active: true,
    building: -1,
    buildigname: ''
};

export interface Room {
    room: number;
    number: string;
    sector: number;
    sectorname: string;
    building: number;
    buildingname: string;
    buildingaddress: string;
    active: boolean;
    bedsquantity: number;
    /** Tipo de habitación: define el nomenclador de estadía. null = sin tipo (no factura estadía). */
    roomtype: number | null;
    roomtypedescription: string | null;
}

export interface RoomType {
    roomtype: number;
    description: string;
    nomenclator: number | null;
    nomenclatordescription: string | null;
    /** Cantidad de habitaciones que lo tienen asignado. Solo lectura. */
    roomsquantity: number;
}

export const defaultRoomType: RoomType = {
    roomtype: -1,
    description: "",
    nomenclator: null,
    nomenclatordescription: null,
    roomsquantity: 0
};

export const defaultRoom: Room = {
    room: -1,
    number: "",
    sector: -1,
    sectorname: "",
    building: -1,
    buildingname: "",
    buildingaddress: "",
    active: true,
    bedsquantity: 0,
    roomtype: null,
    roomtypedescription: null
};

export interface Bed {
    bed: number;
    number: string;
    room: number;
    roomnumber: string;
    sector: number;
    sectorname: string;
    building: number;
    buildingname: string;
    buildingaddress: string;
    healthservice: number | null;
    servicename: string | null;
    bedtype: number;
    bedtypedescription: string;
    active: boolean;
    excludeonstatistics: boolean;
    monitortype: number;
    monitortypename: string;
    monitorip: string;
    monitorport: string;
    monitorcheckperioddefault: number | null;
}

export const defaultBed: Bed = {
    bed: -1,
    number: "",
    room: -1,
    roomnumber: "",
    sector: -1,
    sectorname: "",
    building: -1,
    buildingname: "",
    buildingaddress: "",
    healthservice: -1,
    servicename: "",
    bedtype: 2,
    bedtypedescription: "Cama regular",
    active: true,
    excludeonstatistics: false,
    monitortype: -1,
    monitortypename: "",
    monitorip: "",
    monitorport: "",
    monitorcheckperioddefault: null
};

export interface LocationOption {
    id: number;
    description: string;
}

export interface MediaContent {
    item: number;
    description: string;
    source: string;
}

export const defaultMediaContent: MediaContent = {
    item: -1,
    description: "",
    source: "",
};

export interface PatientCaller {
    patientcallerconfig: number; //pk
    title: string;
    callerid: number; //id puesto por el usuario
    locationdtolist: Box[]; //cada box/consultorio es un renglon en la tabla de llamadores
    active: boolean;
    mediacontentdtolist: MediaContent[]; //asociado a patientCallerPlaylistElement
    mediacontentdtolisttoremove: number[] | null
    establishment: number;
}

export const defaultPatientCaller: PatientCaller = {
    patientcallerconfig: -1,
    title: '',
    callerid: 0,
    locationdtolist: [],
    active: true,
    mediacontentdtolist: [],
    mediacontentdtolisttoremove: null,
    establishment: -1
};

export interface MedicalScheduleTemplate {
    medicalscheduletemplate: number;
    description: string;
}

export const defaultMedicalScheduleTemplate: MedicalScheduleTemplate = {
    medicalscheduletemplate: -1,
    description: ""
}

export interface QueueNumerator {
    queuenumerator: number;
    queuestringid: string; //es la letra, por ej A de adultos, G de guardia, P de pediatría, etc
    optiondescription: string; //es la descripcion de la letra (A -> adultos y asi)
    _order: number;
    lastnumber: number; //los turnos QueueNumber tienen de numero lastNumber+1
    active: boolean;
    medicalscheduletemplate: number; //solo interesa scheduleActivityType 4. Se usa para conocer cuantos pacientes estan esperando a ser atendidos en una especialidad
    medicalscheduletemplatedesc: string;
}

export const defaultQueueNumerator: QueueNumerator = {
    queuenumerator: -1,
    queuestringid: '',
    optiondescription: '',
    _order: 0,
    lastnumber: 0,
    active: true,
    medicalscheduletemplate: -1,
    medicalscheduletemplatedesc: ''
};

export interface Totem {
    totem: number; //pk
    totemapptitle: string;
    totemid: number; //id puesto por usuario
    description: string;
    printerenabled: boolean;
    printerurl: string;
    appointments: boolean;
    appointmentdescription: string;
    queuenumeratordtolist: QueueNumerator[];
    kparameter: number;

    hasWaitingQueue: boolean;
    queuenumeratordescription: string;
    defaultconfirmattend: boolean;
    confirmassitancedescription: string;
    patientregistration: boolean;
    secretaryattendance: boolean;
    secretaryattendancedescription: string;
    active: boolean;
    establishment: number;
    locationdtolist: Box[];
    queuenumeratordtolisttoremove: number[] | null
}

export const defaultTotem: Totem = {
    totem: -1,
    totemapptitle: '',
    totemid: 0,
    description: '',
    printerenabled: false,
    printerurl: '',
    appointments: false,
    appointmentdescription: '',
    queuenumeratordtolist: [],
    kparameter: 0,
    hasWaitingQueue: false,
    queuenumeratordescription: '',
    defaultconfirmattend: false,
    confirmassitancedescription: '',
    patientregistration: false,
    secretaryattendance: false,
    secretaryattendancedescription: '',
    active: true,
    establishment: -1,
    locationdtolist: [],
    queuenumeratordtolisttoremove: null,
};

export interface Establishment {
    buildingid: number;
    buildingname: string;
    buildingaddress: string;
    active: boolean;
    boxes: Box[];
    callers: PatientCaller[];
    sectors: Sector[];
    offices: Office[];
    rooms: Room[];
    beds: Bed[];
}

export const defaultEstablishment: Establishment = {
    buildingid: -1,
    buildingname: '',
    buildingaddress: '',
    active: true,
    boxes: [],
    callers: [],
    sectors: [],
    offices: [],
    rooms: [],
    beds: []
};

export interface AssociatedBox {
    establishment: Establishment;
    sector: Sector;
    box: Box;
}

export const defaultAssociatedBox: AssociatedBox = {
    establishment: null,
    sector: null,
    box: null
};

export interface CallerForm {
    patientCallerId: number,
    name: string;
    callerId: string;
    active: boolean;
    multimedia: MediaContent[];
    associatedBoxes: AssociatedBox[];
}

export const defaultCallerForm: CallerForm = {
    patientCallerId: -1,
    name: '',
    callerId: '',
    active: true,
    multimedia: [],
    associatedBoxes: []
};

export interface SectorForm {
    id: number;
    name: string;
    sectorTypeId: number
    sectorTypeDesc: string;
    externalId: string;
    repositoryId: number;
    repositoryDesc: string;
    workingRepositoryId: number;
    workingRepositoryDesc: string;
    shortName: string;
    acceptsTransfers: boolean;
    restrictRoomGenderControl: boolean;
    prescriptionPriority: string;
    active: boolean;
    establishmentId: number;
}

export const defaultSectorForm: SectorForm = {
    id: -1,
    name: '',
    sectorTypeId: 0,
    sectorTypeDesc: '',
    externalId: '',
    repositoryId: 0,
    repositoryDesc: '',
    workingRepositoryId: 0,
    workingRepositoryDesc: '',
    shortName: '',
    acceptsTransfers: false,
    restrictRoomGenderControl: true,
    prescriptionPriority: '',
    active: true,
    establishmentId: -1
};

export interface TotemForm {
    totem: number;
    name: string;
    totemId: string;
    description: string;
    printerEnabled: boolean;
    printerURL: string;
    appointments: boolean;
    appointmentDesc: string
    waitingQueue: QueueNumerator[];
    kparameter: string;

    hasWaitingQueue: boolean;
    waitingQueueDesc: string;
    confirmAssist: boolean;
    confirmAssistDesc: string;
    patientRegistration: boolean;
    secretaryAttendance: boolean;
    secretaryAttendanceDesc: string;
    active: boolean;

    associatedBoxes: AssociatedBox[];
}

export const defaultTotemForm: TotemForm = {
    totem: -1,
    name: '',
    totemId: '',
    description: '',
    printerEnabled: false,
    printerURL: '',
    appointments: false,
    appointmentDesc: '',
    waitingQueue: [],
    kparameter: '',

    hasWaitingQueue: false,
    waitingQueueDesc: '',
    confirmAssist: false,
    confirmAssistDesc: '',
    patientRegistration: false,
    secretaryAttendance: false,
    secretaryAttendanceDesc: '',
    active: true,

    associatedBoxes: []
};

export interface QueueNumberDTO {
  queuenumber: number | null;
  queuestringid: string;
  optiondescription: string
  number: number;
  recorddate: Date | null;
  callingdate: Date | null;
  calleruser: number | null;
  calleruserdesc: string | null;
  hospitallocation: number | null;
  hospitallocationdesc: string | null;
  associatedpatient: number | null;
  associatedpatientdesc: string | null;
  medicalscheduletemplate: number | null;
}

export const defaultQueueNumberDTO: QueueNumberDTO = {
  queuenumber: null,

  queuestringid: "",
  optiondescription: "",
  number: 0,

  recorddate: null,
  callingdate: null,

  calleruser: null,
  calleruserdesc: "",

  hospitallocation: null,
  hospitallocationdesc: "",

  associatedpatient: null,
  associatedpatientdesc: "",

  medicalscheduletemplate: null,
};
export interface FavoriteStudyDTO {
  favouritestudy: number;
  favouritestudydesc: string;
  studytype: string;
  composedby: string;
  active: boolean;
  ispublic: boolean;
}

export interface FavoriteStudiesFullDTO extends FavoriteStudyDTO {
    favouriteStudiesItem: FavoriteStudyItem[];
}

export interface FavoriteStudyItem {
  favouriteStudyItem: number;
  description: string | null;
  code: string | null;
  favouriteStudyNomenclator: {
    nomenclator: number;
    code: string;
    description: string;
  } | null;
}

export type StudyOrderStatus = "ACTIVA" | "CONSUMIDA" | "VENCIDA";

export interface StudyOrder {
  id: number;
  code: string;
  speciality: string;
  date: string;
  description: string;
  studiesCount: number;
  status: StudyOrderStatus;
}

export type StatusFilter = "ALL" | "ACTIVE" | "CONSUMED" | "EXPIRED";

export interface StudyOrderDTO {
  studyorder: number;
  parenthps?: number;
  orderdate: string;

  patientid?: number;
  patientfullname?: string;

  icondescription: string;
  statetype: number;
  diagnocount: number;

  presumptivediagnostic?: string;

  code?: string;
  studyTypeDescription?: string;
  statusFilterKey?: "ACTIVE" | "CONSUMED" | "EXPIRED";
  statusLabel?: string;
  studiesCount?: number;
}

export type StudyOrderMode = "FAVOURITE" | "NOMENCLATOR" | "FREE_TEXT" | "NOMENCLATOR_SOURCE";
export type NomenclatorSourceId = 1 | 2; // 1=NBU, 2=SNOMED
export type StudyOrderDiagnosisType = "NBU" | "SNOMED" | "FREE_TEXT";

export interface StudyOrderDiseaseDTO {
  disease?: number | null;
  cie10: string;
  name: string;
}

export interface StudyOrderItem {
  id: string;
  code?: string;
  description: string;
  origin: StudyOrderMode;
  nomenclatorId?: number | null;
  nomenclatorSourceId?: NomenclatorSourceId | null;
  observations?: string | null;
  supportedByRepository?: boolean | null;
  unsupportedReason?: string | null;
}

export interface StudyTypeDTO {
  studyType: number;
  i18ncodes?: { description: string }[];
  nomenclatorSourceId?: NomenclatorSourceId | null;
}

export interface PatientBasic {
  firstname: string;
  lastname: string;
  document?: string;
}

export interface StudyOrderData {
  emissionDate?: Date | string | null;
  studyType?: StudyTypeDTO | null;
  diagnosisType?: StudyOrderDiagnosisType;
  diagnosis?: string;
  diagnosisSnomedCode?: string | null;
  diagnosisSnomedDisplay?: string | null;
  diagnosisIcd10Code?: string | null;
  diagnosisIcd10Display?: string | null;
  sampleDescription?: string;
  hidePatientData?: boolean;
  items?: StudyOrderItem[];
}

export interface StudyOrderCopyPayloadDTO {
  patientId: number | null;
  studyTypeId: number | null;
  diagnosisType?: StudyOrderDiagnosisType | null;
  diagnosis: string | null;
  diagnosisSnomedCode?: string | null;
  diagnosisSnomedDisplay?: string | null;
  diagnosisIcd10Code?: string | null;
  diagnosisIcd10Display?: string | null;
  sampleDescription: string | null;
  emissionDate: string | null;
  description: string | null;
  externalId: string | null;
  mailTo: string | null;
  items: Array<{
    code: string | null;
    description: string | null;
    observations: string | null;
    nomenclatorId: number | null;
    nomenclatorSourceId?: NomenclatorSourceId | null;
  }>;
}

export type NomenclatorCodeDTO = {
  id: number;
  code: string;
  description: string;
  categoryid?: number;
  categorydescription?: string;
  supportedByRepository?: boolean;
  unsupportedReason?: string | null;
};
